import { Stack, StackProps, styled } from "@mui/material";

export const ButtonContent = styled((props: StackProps) => <Stack direction="row" gap={2} {...props} />)(({ theme }) => ({
  alignItems: "center",
}));
